import React from 'react';
import './deep-dives-styles.css';
import Header from '../components/header';
import GoToTop from '../components/go-to-top';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import Articol from '../components/article';
import img1 from '../assets/golang-webapp-scr1.png'
import proxyintegration from '../assets/proxyintegration.png';
import apiurl from '../assets/apiurl.png';

class GoLangWebAppCors extends React.Component {
    sendEvent = () => {
        if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
            return;
        }

        if(!sessionStorage.getItem('post-cors')) {
            sessionStorage.setItem('post-cors', true);

            fetch('https://api.ipify.org?format=json')
                .then((ipResp) => ipResp.json().then((ipJson) => {
                    fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
                        method: 'POST',
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({type: 'post-cors', name: 'binaryfusion.ro', from: ipJson}),
                    }).then((response) => response.json().then((responseData) => {
                        sessionStorage.setItem('success', responseData.EventId);
                    }));
                })
            );
        }
    }

    componentDidMount() {
        if(window.location.hostname !== 'localhost' && window.location.hostname.indexOf('192.168.0') === -1) {
            window.scrollTo(0,0);
        }

        this.sendEvent();
    }

    render() {
        const codeStyle = {
            'text-shadow': 'none',
            'border': 'none',
            'box-shadow': 'none',
        };

        return (
            <div>
                <Header />

                <GoToTop />

                <div className='page'>
                    <h1 className='title'>GoLang Webapp on AWS (Part 2) - Front-end and CORS</h1>
                    <div className='paragraph'>
                        Updated on 8 Sept 2024
                    </div>

                    <h5 className='pl-0'>React front-end</h5>

                    <div className='paragraph'>
                        <h5 className='title'>Plan</h5>
                        This article follows the actual timeline in which I did the work on the project. Having ready a simple version of backend, capable of responding to a simple requests
                        the next natural step was to deal with the front-end. The intention was to have a single page with very simple UI that would send a request to the server and react to the 
                        response.<br/><br/>
                        The plan is then, simple:<br/>
                        - create the <strong>API</strong><br/>
                        - create a <strong>React</strong> project and setup the code repository<br/>
                        - add the front-end source code to test communication with the API<br/>
                    </div>


                    <div className='paragraph'>
                        <h5 className='title'>API Gateway</h5>
                        I've done this by using the AWS console <strong>API Gateway</strong>. The variant I used is the <strong>REST API</strong>, selected <strong>New API</strong> and left everything else as is.
                        I then created the resource, lets call it here <inline-code>/users</inline-code> and checked the <strong>CORS checkbox</strong>. With the <inline-code>/users</inline-code> resource selected, 
                        in the methods section, I created a new POST method. No reason behind the choice of method type.
                    </div>

                    <div className='paragraph'>
                        To create the <strong>REST API Gateway</strong> I selected:<br/>
                        - Method type POST,<br/>
                        - Integration type Lambda function,<br/>
                        - checked Lambda function integration,<br/>
                        - selected from the dropdown the Lamda function created previously<br/>
                    </div>

                    <div className='paragraph'>
                        Things that it's worth pointing out here are: <br/>
                        1. I selected <strong>Lambda proxy integration</strong> because this has the effect that when I will receive the request inside the Lambda function's docker container, I will be able to read. Check the fig 1 bellow.
                        the <strong>request path</strong>. I want to do this so that I will be able to handle multipe types of requests using the same Lambda function and only by means of source code. If you think this is
                        an unreasonable approach for a small scale web app please let me know with an email.<br/>
                        2. The second thing to mention is that the location chosen, in the dropdown, for the Lambda function must be pointing to the same geographic area as when you created your Lambda function.
                    </div>

                    <img alt='lambda proxy integration screenshot' className='img-row high' src={proxyintegration } />

                    <div className='paragraph'>
                        I did not do any other configurations in the rest of the sections. When this is done, we can check the working of the API and the connection to the Lambda, again by using <inline-code>curl</inline-code>
                        
                        <div className='code'>
                            curl -v -X GET https://xxx.execute-api.eu-central-1.amazonaws.com/prod/create_robot
                        </div>

                        You can obtain the URL of your API and for this specific resource, from "Stages" section if the API Gateway
                    </div>

                    <img alt='lambda proxy integration screenshot' className='img-row' src={apiurl} />

                    <div className='paragraph'>
                        <h5 className='title'>React project</h5>
                        Now, having where to send our requests it's time for the front-end code.
                        I started by locally creating the <strong>React</strong> project with

                        <div className='code'>
                            npx-create-react-app my-new-project
                        </div>
                    </div>

                    <div className='paragraph'>
                        In order to make calls from a React front-end to the <strong>AWS REST API</strong>, we need the dedicated node library called <inline-code>aws-aplify</inline-code>.
                        More documentation you can find at their <a href='https://www.npmjs.com/package/aws-amplify' target='_blank' rel='noreferrer'>npm page</a> and on <a href='https://docs.amplify.aws/javascript/' target='_blank' rel='noreferrer'>Amplify Docs</a>. You can install it, of course with 

                        <div className='code'>
                           npm install aws-amplify
                        </div>

                        You also need to configure <strong>aws-amplify</strong> to have the configuration details about your API: <strong>endpoint address, region</strong>. For this, I added this configuration to my <inline-code>index.js</inline-code> file:
                        <SyntaxHighlighter language='javascript' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                            {`import { Amplify } from 'aws-amplify';

const existingConfig = Amplify.getConfig();

Amplify.configure({
  ...existingConfig,
  API: {
    ...existingConfig.API,
    REST: {
      ...existingConfig.API?.REST,
      'API Gateway name': {
        endpoint: 'https://xxxxxxxx.execute-api.eu-central-1.amazonaws.com/prod',
        region: 'eu-central-1',
      }
    }
  }
});`}
                        </SyntaxHighlighter>
                        The <strong>API Gateway name</strong> it's a name by which you will reference this configuration later, when making the actual HTTP call. Obviously, it makes sense to name it somehow descriptive of the name of the API Gateway in AWS.
                        <br/>
                        As per documentation, <inline-code>existingConfig</inline-code> is used to supply the full resource configuration and library options objects. The code I used above, is getting the existing Amplify project configuration from the default location <inline-code>~/.aws/config</inline-code> 
                        and then it changes it in the following line adding the API and REST configuration. From the original configuration, in my case is getting the user used to make the subsequent calls to the API.
                    </div>

                    <div className='paragraph'>
                        The next part of the code is showing how I am sending the HTTP calls:
                        <SyntaxHighlighter language='javascript' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                            {`async function postRobots() {
  try {
    const reqData = {prop1: 'A', prop2: 'B', source: 'B',};
    const restOperation = post({
      apiName: 'API Gateway name',
      path: '/robots',
      options: {
        headers: {
          "content-type": "application/x-www-form-urlencoded"
        },
        body: reqData
      }
    });
    const response = await restOperation.response;
    setData("OK");
    setError(null);
  } catch (e) {
    setData("FAILED");
    setError('PUT call failed');
  }
}

const LambdaButton = () => {
  const testLambdaFc = () => {
    postRobots();
  };

  return <div className='btn' role="button" onClick={testLambdaFc}>Test Lambda function</div>
}`}
                        </SyntaxHighlighter>
                    </div>

                    <div className='paragraph'>
                        In order to test this code in relation to the previously discussed <strong>Lambda function</strong>, I need to either run the project locally or push it to an Amplify app. I decided to first
                        do this on localhost. This is where CORS errors had to be handled. The <strong>CORS</strong> errors appear for security reasons to prevent the web pages from making requests to an unintended resource.
                        The expected way is that the webpage should make requests only to the domain who served the page. It's clear that in our case this will not be possible.
                    </div>

                    <div className='paragraph'>
                        I am using here a single <strong>Lambda function</strong> to process all the types of requests. There are multiple approaches in this respect but my plan was to eventually use different Lambda functions for each resource. So this time I used regex patterns to differentiate between requests and call for each request a different handler function.
                    </div>

                        <SyntaxHighlighter language='javascript' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                            {`package main

import (
	"errors"
	"regexp"

	"github.com/aws/aws-lambda-go/events"
	"github.com/aws/aws-lambda-go/lambda"

	internal "example.com/on_path_robotics2/internal"
)

func main() {
	lambda.Start(handler)
}

func handler(request events.APIGatewayProxyRequest) (events.APIGatewayProxyResponse, error) {
	matched, err := regexp.Match('.*/robots$', []byte(request.Path))
	if err == nil && matched {
		return internal.GetLambdaGateway().HandleGetRobotsRequest(request)
	}

	matched, err = regexp.Match('.*/get_robots$', []byte(request.Path))
	if err == nil && matched {
		return internal.GetLambdaGateway().HandleGetRobotsRequest(request)
	}

	matched, err = regexp.Match('.*/create_robot$', []byte(request.Path))
	if err == nil && matched {
		return internal.GetLambdaGateway().HandleCreateRobotRequest(request)
	}

	return internal.GetLambdaGateway().GetInvalidRequestResponse(request), errors.New("path not defined. Request path is " + request.Path)
}`}
                        </SyntaxHighlighter>

                    <div className='paragraph'>
                        <h5 className='mt-10 title'>CORS</h5>
                        If we test the communication between React.js front-end  and the API on the local machine, the page will be served by the domain <strong>localhost</strong> and the requests to the API will be made to the domain <strong>https://xxxxxx.execute-api.eu-central-1.amazonaws.com</strong>, 
                        clearly violating the CORS rule. The same problem applies if we make the requests from Cloud9 environment or from the published Amplify app.

                        <div className='table domains'>
                            <div className='header'>Use case</div>
                            <div className='header'>Request Domain</div>
                            <div className='header'>Response Domain</div>
                            <div>Local machine</div>
                            <div>localhost</div>
                            <div>xxx.execute-api.eu-central-1.amazonaws.com</div>
                            <div>Cloud9 environment</div>
                            <div>xxx.vfs.cloud9.eu-central-1.amazonaws.com</div>
                            <div>xxx.execute-api.eu-central-1.amazonaws.com</div>
                            <div>Amplify app</div>
                            <div>master.d3cwzm2wqq04zv.amplifyapp.com</div>
                            <div>xxx.execute-api.eu-central-1.amazonaws.com</div>
                        </div>

                        To solve this issue, we need to make the browser understand that it's a legitimate possibility to receive requests from these domains so it's ok to let the response go through.
                        In such a case the header <strong>Access-Control-Allow-Origin</strong> is usefull. The browser will check that the response from the server will have this header set and the value 
                        will match the domain who initially served the web page. In even less technical terms, the browser will check that the communication between the requesting domain and the responding domain is agreed upon beforehand.
                    </div>
                        
                    <div className='paragraph'>
                        Two things needs to be accomplished:<br/>
                        - CORS needs to be activated in the <strong>API Gateway</strong> for the specific resource I am making the call.<br/>
                        - We need to make sure to add the response header <strong>Access-Control-Allow-Origin</strong> and that it has the correct value
                    </div>

                    <img alt='adding CORS to API Gateway' className='img-row' src={img1} />
                    <div className='paragraph'>
                        The effect of using "Enable CORS" button on the API Gateway Resources list, is that it will generate the <strong>OPTIONS</strong> method. 
                        A <strong>preflight request</strong> is made with the OPTIONS method to make sure that the server will accept the
                        subsequent request. One can request permission to the server for the next request header, method and domain origin. The server's responability is to provide a response to the permissions
                        request. The values of Access-Control-Allow-Origin, Access-Control-Allow-Methods and Access-Control-Allow-Headers togetgher with the Status code, will show if the origin domain is permitted
                        to make requests to the API Gateway end-point.
                    </div>

                    <div className='paragraph'>
                        The response Access-Control-Allow-* headers must be added by the server code, by the developer. Because I wanted to be able to run the same Lambda Function code regardless if the 
                        requests were generated with the domanin localhost, cloud9 environemnt or the published app on Amplify I decided to use a property on the request payload named "Source". Based on that
                        I added the necessary value for the Access-Control-Allow-Origin header.

                        <SyntaxHighlighter language='go' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                            {`func (l LambdaGateway) HandleCreateRobotRequest(request events.APIGatewayProxyRequest) (events.APIGatewayProxyResponse, error) {
	var requestBody CreateRobotRequest
	err := json.Unmarshal([]byte(request.Body), &requestBody)

	if err != nil {
		fmt.Printf("Error parsing request body: %v", err)
		errorResp, err := generateErrorReponse()
		addHeaders(&errorResp, *requestBody.Source)
		return errorResp, err
	}

	robotData := l.robotsDelegate.CreateRobot(requestBody)

	response, err := generateResponse(robotData)
	addHeaders(&response, *requestBody.Source)
	return response, err
}

                            
func addHeaders(response *events.APIGatewayProxyResponse, source string) {
	hdrs := map[string]string{}

	if source == "A" {
		hdrs["Access-Control-Allow-Origin"] = "http://localhost:3000"
	} else if strings.Contains(source, "B") {
		hdrs["Access-Control-Allow-Origin"] = "https://master.d3cwzm2wqq04zv.amplifyapp.com" // From published app on prod stage
	} else if strings.Contains(source, "C") {
		hdrs["Access-Control-Allow-Origin"] = "https://xxx.vfs.cloud9.eu-central-1.amazonaws.com" // From Cloud9 env
	} else {
		hdrs["Access-Control-Allow-Origin"] = "http://localhost:3000"
	}

	response.Headers = hdrs
}`}
                        </SyntaxHighlighter>
                        The important part I want to point out in the code above, on line 14 - 15, after I obtain the response to be sent back to 
                        the front-end, I am adding the necessary CORS headers so that the request will be permitted to be processed. Adding the header is 
                        straight forward: get the domain from the request and added back to the response.
                    </div>


                    <div className='side-story'>
                        <h2>Side story: Adding Google fonts</h2>

                        <div className='paragraph'>
                            If you want to use <a target='_blank' rel='noreferrer' href='https://fonts.google.com/'>Google Fonts</a> in a React front-end, I will show here how I did it:<br/>
                            1. I added to <inline-code>public/index.html</inline-code> the links obtained from "Get font" button in the "Web" section:

                            <SyntaxHighlighter language='html' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                                {`<head>
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Varela+Round&display=swap" rel="stylesheet">
    </head>`}
                            </SyntaxHighlighter>
                            2. In <inline-code>index.css</inline-code> I can now use
                            <SyntaxHighlighter language='css' style={dark} showLineNumbers='true' customStyle={codeStyle}>
                                {`body {
  font-family: "Varela Round", sans-serif;
  font-weight: 400;
  font-style: normal;

  ...
}`}
                            </SyntaxHighlighter>
                        </div>
                    </div>

                    <h5>Next</h5>
                    <div className='paragraph'>
                        In the next article I will describe how I connected the Go lang Lambda function code to the DynamoDB in AWS. Of course, I hope you
                        found something usefull here for your project and if you can provide me with any feedback feel free to send an email. It will be much appreciated.
                    </div>

                    <div className='articles mt-5'>
                        <Articol title='GoLang Web app on AWS (Part 1) - ECR and Lambda' to={'/dp-golang-webapp-ecr'} />
                        <Articol title='GoLang Web app on AWS (Part 3) - DynamoDB' to={'/dp-golang-webapp-dynamodb'} />
                    </div>

                    <div className='mb-10'></div>
                </div>
            </div>
        )
    }
}

export default GoLangWebAppCors;